function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { ModuleLink, ModuleTitle, ModuleDescription, ModuleMetadata } from '../Module';
import { FormatMetric } from "../";
import { getUrlFromProps } from "../../resources/functions/";

class AnalyticsTableBodyRow extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getClassName", () => {
      return "admin-analytics-table__row";
    });

    _defineProperty(this, "renderDimensions", () => {
      const _this$props = this.props,
            dimensions = _this$props.dimensions,
            thStyle = _this$props.thStyle,
            urlPattern = _this$props.urlPattern;
      let metadata = [];

      if (dimensions.length >= 2) {
        metadata = dimensions.slice(1, dimensions.length);
      }

      const url = getUrlFromProps(this.props, urlPattern);

      if (url) {
        metadata.push(url);
      }

      const title = dimensions[0];
      const description = metadata.join('–');
      return React.createElement("th", {
        style: thStyle
      }, React.createElement(ModuleLink, {
        url: url
      }, React.createElement(ModuleTitle, {
        title: dimensions[0]
      }), React.createElement(ModuleMetadata, {
        metadata: metadata
      })));
      return React.createElement("th", {
        style: thStyle
      }, title, description);
    });

    _defineProperty(this, "renderMetricValue", (metric, index) => {
      const _this$props2 = this.props,
            metrics = _this$props2.metrics,
            totals = _this$props2.totals,
            sortBy = _this$props2.sortBy,
            tdStyle = _this$props2.tdStyle;
      const name = metric.name,
            type = metric.type;
      const value = metrics[0].values[index];
      let selected;

      if (sortBy === name) {
        selected = true;
      }

      const pctOfTotal = value / totals[index] * 100;
      return React.createElement("td", {
        style: tdStyle,
        key: index,
        "aria-selected": selected
      }, React.createElement("b", null, React.createElement(FormatMetric, _extends({}, metric, {
        value: value
      }))), React.createElement("i", null, React.createElement(FormatMetric, {
        type: "PERCENT",
        value: pctOfTotal
      })));
    });

    _defineProperty(this, "renderMetrics", () => {
      const metricHeaders = this.props.metricHeaders;
      return metricHeaders.map(this.renderMetricValue);
    });
  }

  render() {
    const className = this.getClassName();
    return React.createElement("tr", {
      className: className
    }, this.renderDimensions(), this.renderMetrics());
  }

}

_defineProperty(AnalyticsTableBodyRow, "defaultProps", {
  dimensions: [],
  metrics: [],
  urlPattern: undefined
});

export default AnalyticsTableBodyRow;